import React, { useState, useCallback } from 'react';
import { motion } from "framer-motion";
import ReactDOM from 'react-dom';
import { Link } from "react-router-dom";

import Icon from "src/components/Icon/Icon";

import styles from './Drawer.module.scss';

export interface IMenuItem {
    label: string,
    url: string,
    icon?: string
}

interface IProps {
  isShown: boolean,
  hide: () => void,
  menuItems?: IMenuItem[],
  className?: string,
  expand?: boolean
}

export const useDrawer = () => {
  const [isShown, setIsShown] = useState<boolean>(false);

  const toggle = useCallback(() => {
    if (isShown && document.body.getElementsByClassName("Drawer").length < 2) {
      document.body.style.overflow = 'unset';
    } else {
      document.body.style.overflow = 'hidden';
    }

    setIsShown(!isShown);
  }, [isShown]);

  return { isShown, toggle };
};

export const Drawer: React.FC<IProps> = (props) => {
  const drawer = (
    <motion.div initial={{ opacity: 0, }} whileInView={{ opacity: 1 }} transition={{ duration: 0.1 }} className={"Drawer " + (props.className ? `${styles.Drawer} ${props.className}` + props.className : `${styles.Drawer} ${props.className}`)} onClick={props.hide}>
        <motion.div onClick={(e) => { e.stopPropagation(); }}initial={{ left: -320 }} transition={{ duration: 0.3 }} whileInView={{ left: 0 }} className={styles.inner}>
            <ul className={styles.list}>
                {props.menuItems && props.menuItems.map((item: IMenuItem, index: number) => {
                    return (<li key={"item"+index}>
                        <Link to={item.url} onClick={() => { props.hide(); }}>
                            {item.icon && <Icon className={styles.itemIcon} type={item.icon} />}
                            <span>{item.label}</span>
                        </Link>
                    </li>);
                })}
            </ul>
            <div className={styles.close} onClick={() => { props.hide(); }}>
                <Icon className={styles.closeIcon} type="close" />
            </div>
        </motion.div>
    </motion.div>
  );

  return props.isShown ? ReactDOM.createPortal(drawer, document.body) : null;
}